import moment from 'moment';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { toLower, toUpper } from 'lodash';
import Resizer from 'react-image-file-resizer';
import Moment from 'react-moment';
import CONSTANTS from '../constants/constant';
import { FormattedNumber } from 'react-intl';

const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const mentionRegex = /\{\{(.*?)\}\}+/g;
const mentionDetailRegex = /(?<=\{\{)(.*?)(?=\}\})+/g;

export const VEHICLE_TYPES: string[] = [
  '1 TẤN',
  '2 TẤN',
  '3 TẤN',
  '4 TẤN',
  '5 TẤN',
  '6 TẤN',
  '7 TẤN',
  '8 TẤN',
  '2 CHÂN',
  '3 CHÂN',
  '4 CHÂN',
  '5 CHÂN',
  'ĐẦU KÉO',
  'MOOC SÀN',
  'MOOC XƯƠNG',
  'PHOOC LÙN',
  'CONT',
  'CONT CẮT NÓC',
];

export const VEHICLE_TYPES_FILTER: string[] = [
  '1 TẤN',
  '2 TẤN',
  '3 TẤN',
  '4 TẤN',
  '5 TẤN',
  '6 TẤN',
  '7 TẤN',
  '8 TẤN',
  '2 CHÂN',
  '3 CHÂN',
  '4 CHÂN',
  '5 CHÂN',
  'ĐẦU KÉO',
  'MOOC SÀN',
  'MOOC XƯƠNG',
  'PHOOC LÙN',
  'CONT',
  'CONT NÓNG',
  'CONT LẠNH',
  'CONT CẮT NÓC',
];

export const VEHICLE_TYPE_1: string[] = [
  '1 TẤN',
  '2 TẤN',
  '3 TẤN',
  '4 TẤN',
  '5 TẤN',
  '6 TẤN',
  '7 TẤN',
  '8 TẤN',
  '2 CHÂN',
  '3 CHÂN',
  '4 CHÂN',
  '5 CHÂN',
];

export const VEHICLE_TYPE_2: string[] = ['ĐẦU KÉO', 'MOOC SÀN', 'MOOC XƯƠNG', 'PHOOC LÙN'];

export const VEHICLE_TYPE_3: string[] = ['CONT'];

export const VEHICLE_TYPE_4: string[] = ['CONT CẮT NÓC'];

export const VEHICLE_CONTAINER_TYPE_1: any = [
  { label: 'THÙNG KÍN', value: 'THÙNG KÍN' },
  { label: 'THÙNG BẠT', value: 'THÙNG BẠT' },
  { label: 'THÙNG LẠNH', value: 'THÙNG LẠNH' },
];

export const VEHICLE_CONTAINER_TYPE_2: any = [
  { label: 'NÓNG', value: 'NÓNG' },
  { label: 'LẠNH', value: 'LẠNH' },
];

export const UNIT_OPTIONS: any[] = [
  { label: 'CHUYẾN', value: 'CHUYẾN' },
  { label: 'CONT', value: 'CONT' },
  { label: 'XE', value: 'XE' },
  { label: 'TẤN', value: 'TẤN' },
  { label: 'KHỐI', value: 'KHỐI' },
  { label: 'KIỆN', value: 'KIỆN' },
  { label: 'THÙNG', value: 'THÙNG' },
  { label: 'PALLET', value: 'PALLET' },
  { label: 'LÔ', value: 'LÔ' },
  { label: 'CÁI', value: 'CÁI' },
  { label: 'KG', value: 'KG' },
  { label: 'TRÁI', value: 'TRÁI' },
];

export const REQUIRED_WEIGHT_OPTIONS: any[] = [
  { label: 'NHẸ TẢI', value: 'NHẸ TẢI' },
  { label: 'ĐỦ TẢI', value: 'ĐỦ TẢI' },
  { label: 'QUÁ TẢI', value: 'QUÁ TẢI' },
];

export const PPHH_OPTIONS: any[] = [
  { label: 'HÀNG NGUYÊN XE', value: 'HÀNG NGUYÊN XE' },
  { label: 'HÀNG GHÉP', value: 'HÀNG GHÉP' },
];

export const PRICE_QUOTE_TYPES: string[] = ['CÓ XE NHẬN', 'THAM KHẢO GIÁ'];

export const PP_VAN_CHUYEN_OPTIONS: any[] = [
  {
    label: 'ĐƯỜNG BỘ',
    value: 'ĐƯỜNG BỘ',
  },
  {
    label: 'ĐƯỜNG SẮT',
    value: 'ĐƯỜNG SẮT',
  },
  {
    label: 'ĐƯỜNG BIỂN',
    value: 'ĐƯỜNG BIỂN',
  },
  {
    label: 'TRUCKING HÀNG 2 CHIỀU',
    value: 'TRUCKING HÀNG 2 CHIỀU',
  },
];

// Cấu trúc miền / mã vùng - dùng chung với NotificationBar.tsx (tránh hard-code rải rác).
export const REGION_GROUPS: { [region: string]: string[] } = {
  'MIỀN BẮC': ['B1', 'B2'],
  'MIỀN TRUNG': ['T1', 'T2', 'T3'],
  'MIỀN NAM': ['N1'],
  'TÂY NGUYÊN': ['TN1'],
  'MIỀN TÂY': ['MT1', 'MT2'],
};

export const REGION_GROUP_OPTIONS: { label: string; value: string }[] = Object.keys(REGION_GROUPS).map((label) => ({
  label,
  value: label,
}));

export const HINH_THUC_GIAO_NHAN_OPTIONS: any[] = [
  {
    label: 'NHẬN TẠI NHÀ KHÁCH - GIAO TẠI NHÀ KHÁCH',
    value: 'NHẬN TẠI NHÀ KHÁCH - GIAO TẠI NHÀ KHÁCH',
  },
  {
    label: 'NHẬN TẠI NHÀ KHÁCH - GIAO TẠI KHO NHẬN',
    value: 'NHẬN TẠI NHÀ KHÁCH - GIAO TẠI KHO NHẬN',
  },
  {
    label: 'NHẬN TẠI KHO NHẬN HÀNG - GIAO TẠI KHO NHẬN HÀNG',
    value: 'NHẬN TẠI KHO NHẬN HÀNG - GIAO TẠI KHO NHẬN HÀNG',
  },
  {
    label: 'NHẬN TẠI KHO NHẬN HÀNG - GIAO TẠI NHÀ KHÁCH',
    value: 'NHẬN TẠI KHO NHẬN HÀNG - GIAO TẠI NHÀ KHÁCH',
  },
];

export const VEHICLE_METHOD_OPTIONS: any = [
  { label: 'Đường bộ', value: 'Đường bộ' },
  { label: 'Đường sắt', value: 'Đường sắt' },
  { label: 'Đường biển', value: 'Đường biển' },
];

export const HUB_OPTIONS: any[] = [
  { label: 'HUB 1A NINH BÌNH - QUẢNG BÌNH', value: 'HUB 1A NINH BÌNH - QUẢNG BÌNH' },
  { label: 'HUB 1B QUẢNG BÌNH - NINH BÌNH', value: 'HUB 1B QUẢNG BÌNH - NINH BÌNH' },
  { label: 'HUB 2A QUẢNG BÌNH - QUẢNG NGÃI', value: 'HUB 2A QUẢNG BÌNH - QUẢNG NGÃI' },
  { label: 'HUB 2B QUẢNG NGÃI - QUẢNG BÌNH', value: 'HUB 2B QUẢNG NGÃI - QUẢNG BÌNH' },
  { label: 'HUB 3A QUẢNG NGÃI - KHÁNH HÒA', value: 'HUB 3A QUẢNG NGÃI - KHÁNH HÒA' },
  { label: 'HUB 3B KHÁNH HÒA - QUẢNG NGÃI', value: 'HUB 3B KHÁNH HÒA - QUẢNG NGÃI' },
  { label: 'HUB 4A KHÁNH HÒA - ĐỒNG NAI', value: 'HUB 4A KHÁNH HÒA - ĐỒNG NAI' },
  { label: 'HUB 4B ĐỒNG NAI - KHÁNH HÒA', value: 'HUB 4B ĐỒNG NAI - KHÁNH HÒA' },
];

export const CURRENT_LOCATION_OPTIONS: any[] = [
  { label: 'NINH BÌNH', value: 'NINH BÌNH' },
  { label: 'QUẢNG BÌNH', value: 'QUẢNG BÌNH' },
  { label: 'QUẢNG NGÃI', value: 'QUẢNG NGÃI' },
  { label: 'KHÁNH HÒA', value: 'KHÁNH HÒA' },
  { label: 'ĐỒNG NAI', value: 'ĐỒNG NAI' },
];

export const HANG_BANG_LAI_OPTIONS: any[] = [
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' },
  { label: 'E', value: 'E' },
  { label: 'FC', value: 'FC' },
];

export const VERSION_WRAPPER: any = {
  52: '3.2.9',
  48: '3.2.6',
  39: '3.1.6',
  20: '3.0.9',
  19: '3.0.8',
  18: '3.0.8',
  17: '3.0.8',
  15: '3.0.7',
  13: '3.0.6',
  12: '3.0.5',
  11: '3.0.4',
  10: '3.0.3',
  7: '3.0.2',
  6: '3.0.1',
  5: '3.0.0',
};

export const PLATFORM_OPTIONS: any[] = [
  { label: 'Tất cả', value: '' },
  { label: 'ANDROID', value: 'android' },
  { label: 'IOS', value: 'ios' },
];

export const VIEW_TYPE_OPTIONS: any[] = [
  {
    label: 'Chỉ xem đơn của tôi',
    value: '1',
  },
  {
    label: 'Xem tất cả đơn',
    value: '',
  },
];

export const LOAI_DON_HANG_FILTER_OPTIONS: any[] = [
  {
    label: 'Tất cả loại đơn',
    value: '',
  },
  {
    label: 'Đơn hàng thường',
    value: 'thuong',
  },
  {
    label: 'Đơn hàng phòng thầu',
    value: 'phong_thau',
  },
];

export const KIEU_HH_OPTIONS: any[] = [
  {
    label: 'Tất cả',
    value: '',
  },
  {
    label: 'Hàng nguyên xe',
    value: 'Hàng nguyên xe',
  },
  {
    label: 'Hàng ghép',
    value: 'Hàng ghép',
  },
];

export const CHAT_NAME_COLORS = [
  '#DB2D43',
  '#9F2B68',
  '#3B7A57',
  '#9966CC',
  '#0048BA',
  '#4B6F44',
  '#007FFF',
  '#DA1884',
  '#848482',
  '#2E5894',
  '#3D2B1F',
  '#000000',
  '#54626F',
  '#A57164',
  '#660000',
  '#0087BD',
  '#DE5D83',
  '#004225',
  '#CC5500',
  '#006B3C',
  '#00CC99',
  '#703642',
  '#2A52BE',
  '#E23D28',
  '#6495ED',
  '#006400',
  '#8B008B',
];

export const VEHICLE_REGISTER_OPTIONS: any = [
  { label: 'Hãy chọn', value: '' },
  { label: 'XE CÁ NHÂN', value: 'XE CÁ NHÂN' },
  { label: 'XE CÔNG TY', value: 'XE CÔNG TY' },
];

export const LOAI_HINH_XE_OPTIONS: any = [
  {
    label: 'Vay ngân hàng',
    value: 'Vay ngân hàng',
  },
  {
    label: 'Không vay',
    value: 'Không vay',
  },
];

export const BAO_HIEM_OPTIONS: any = [
  {
    label: 'Bảo Minh',
    value: 'Bảo Minh',
  },
  {
    label: 'Bảo Việt',
    value: 'Bảo Việt',
  },
  {
    label: 'Hàng Không - VNI',
    value: 'Hàng Không - VNI',
  },
  {
    label: 'Dầu Khí - PVI',
    value: 'Dầu Khí - PVI',
  },
  {
    label: 'PETROLIMEX - PJICO',
    value: 'PETROLIMEX - PJICO',
  },
  {
    label: 'Bưu điện - PTI',
    value: 'Bưu điện - PTI',
  },
  {
    label: 'Quân đội - MIC',
    value: 'Quân đội - MIC',
  },
  {
    label: 'BIDV - BIC',
    value: 'BIDV - BIC',
  },
  {
    label: 'Bảo Long',
    value: 'Bảo Long',
  },
  {
    label: 'Xuân Thành',
    value: 'Xuân Thành',
  },
  {
    label: 'Viễn Đông - VASS',
    value: 'Viễn Đông - VASS',
  },
  {
    label: 'AAA',
    value: 'AAA',
  },
  {
    label: 'NH SHB - BSH',
    value: 'NH SHB - BSH',
  },
  {
    label: 'Cathay',
    value: 'Cathay',
  },
  {
    label: 'Toàn cầu',
    value: 'Toàn cầu',
  },
  {
    label: 'NH Nông Nghiệp - ABIC',
    value: 'NH Nông Nghiệp - ABIC',
  },
  {
    label: 'HÙNG VƯƠNG',
    value: 'HÙNG VƯƠNG',
  },
  {
    label: 'VIỄN ĐÔNG',
    value: 'VIỄN ĐÔNG',
  },
  {
    label: 'TASCO',
    value: 'TASCO',
  },
  {
    label: 'VIETINBANK',
    value: 'VIETINBANK',
  },
  {
    label: 'LPBANK - LPBI',
    value: 'LPBANK - LPBI',
  },
];

export const BHTN_OPTIONS: any = [
  {
    label: 'Có',
    value: 'Có',
  },
  {
    label: 'Không',
    value: 'Không',
  },
];

export const TRIEN_KHAI_OPTIONS = [
  { label: 'LÀM MỚI', value: 'LÀM MỚI' },
  { label: 'FIX LỖI LỚN', value: 'FIX LỖI LỚN' },
  { label: 'FIX LỖI NHỎ', value: 'FIX LỖI NHỎ' },
];

export const TRIEN_KHAI_2_OPTIONS = [
  { label: 'CÔNG VIỆC HÀNG NGÀY', value: 'CÔNG VIỆC HÀNG NGÀY' },
  { label: 'CÔNG VIỆC THEO DEADLINE', value: 'CÔNG VIỆC THEO DEADLINE' },
  { label: 'CÔNG VIỆC THƯỜNG XUYÊN', value: 'CÔNG VIỆC THƯỜNG XUYÊN' },
];

export const TIEN_DO_OPTIONS = [
  { label: 'VIỆC GẤP', value: 'VIỆC GẤP' },
  { label: 'KHÔNG GẤP', value: 'KHÔNG GẤP' },
];

export const PHONG_BAN_OPTIONS = [
  { label: 'PHÒNG KINH DOANH', value: 'PHÒNG KINH DOANH' },
  { label: 'PHÒNG KẾ TOÁN', value: 'PHÒNG KẾ TOÁN' },
  { label: 'PHÒNG NHÂN SỰ', value: 'PHÒNG NHÂN SỰ' },
  { label: 'PHÒNG PHÁP CHẾ', value: 'PHÒNG PHÁP CHẾ' },
  { label: 'PHÒNG AI', value: 'PHÒNG AI' },
];

/**
 * Tên BÊN (`loai_hd`) để IN RA MÀN HÌNH: máy chủ/API dùng 'CHỦ HÀNG' / 'CHỦ XE',
 * người dùng gọi bên thứ nhất là KHÁCH HÀNG (QA 28/08/2026 K5, chốt 08/09/2026:
 * đổi nhãn hiển thị ở cả web lẫn app, KHÔNG đổi giá trị gửi lên API).
 * Cùng hàm bên app: `tenBenHienThi()` trong `core/utils/ten_ben_hien_thi.dart`.
 */
export const tenBenHienThi = (loaiHd?: string | null): string => {
  const v = (loaiHd || '').trim();
  return v.toUpperCase() === 'CHỦ HÀNG' ? 'KHÁCH HÀNG' : v;
};

export const PAYMENT_TYPES: any = {
  cx_tong_thanh_tien: '[527] THANH TOÁN CƯỚC CHO TÀI XẾ',
  phi_dv_hh: '[211] THANH TOÁN PHÍ DỊCH VỤ HÀNG HÓA 1',
  phi_dv_hh_2: '[212] THANH TOÁN PHÍ DỊCH VỤ HÀNG HÓA 2',
  phi_dv_cho_xe: '[213] THANH TOÁN PHÍ DỊCH VỤ CHO XE 1',
  phi_dv_cho_xe_2: '[214] THANH TOÁN PHÍ DỊCH VỤ CHO XE 2',
  phat_sinh_den_bu: '[215] THANH TOÁN PHÁT SINH ĐỀN BÙ',
  vic_back_khach_hang: '[312] THANH TOÁN VIC BACK LẠI CHO KHÁCH HÀNG',
  ctv_sm_kpi: '[611] THANH TOÁN CTV SM KPI',
  ctv_f1_kpi: '[612] THANH TOÁN CTV F1 KPI',
  ctv_f2_kpi: '[613] THANH TOÁN CTV F2 KPI',
  hoan_thanh_don_hang: 'THANH TOÁN HOÀN THÀNH ĐƠN',
};

export const PAYMENT_TYPES_COMPANY_OPTIONS = [
  { label: 'CÔNG TY', value: 'CÔNG TY' },
  { label: 'CÔNG TY - THU HỘ', value: 'CÔNG TY - THU HỘ' },
  { label: 'CÔNG TY - PHÍ DỊCH VỤ', value: 'CÔNG TY - PHÍ DỊCH VỤ' },
];

export const PAYMENT_TYPES_OPTIONS = [
  { label: 'CÔNG TY', value: 'CÔNG TY' },
  { label: 'CÔNG TY - THU HỘ', value: 'CÔNG TY - THU HỘ' },
  { label: 'CÔNG TY - PHÍ DỊCH VỤ', value: 'CÔNG TY - PHÍ DỊCH VỤ' },
  { label: 'THU HỘ', value: 'THU HỘ' },
  { label: 'PHÍ DỊCH VỤ', value: 'PHÍ DỊCH VỤ' },
];

export const SO_NGAY_QUA_HAN_OPTIONS = [
  { label: 'Tất cả', value: '' },
  { label: 'ĐÚNG HẠN', value: 'ĐÚNG HẠN' },
  { label: 'QUÁ HẠN', value: 'QUÁ HẠN' },
];

export const HDKT_LOAI_HD_OPTIONS: any[] = [
  { label: 'CHỦ HÀNG', value: 'CHỦ HÀNG' },
  { label: 'CHỦ XE', value: 'CHỦ XE' },
];

export const HDKT_LOAI_HOP_DONG_OPTIONS: any[] = [
  { label: 'HỢP ĐỒNG THEO NĂM', value: 'HỢP ĐỒNG THEO NĂM' },
  { label: 'HỢP ĐỒNG THEO CHUYẾN', value: 'HỢP ĐỒNG THEO CHUYẾN' },
];

export const HDKT_HOAN_THIEN_OPTIONS: any[] = [
  { label: 'ĐÃ KÝ', value: 'ĐÃ KÝ' },
  { label: 'CHƯA KÝ', value: 'CHƯA KÝ' },
];

export const TEAM_OPTIONS = [
  { label: 'TEAM VĂN PHÒNG', value: 'TEAM VĂN PHÒNG' },
  { label: 'TEAM CTV', value: 'TEAM CTV' },
  { label: 'TEAM TRUCKER', value: 'TEAM TRUCKER' },
  { label: 'TEAM TRANSPORT', value: 'TEAM TRANSPORT' },
  { label: 'TEAM TRUCKING', value: 'TEAM TRUCKING' },
  { label: 'TEAM SHIPPING', value: 'TEAM SHIPPING' },
  { label: 'TEAM IT', value: 'TEAM IT' },
  { label: 'TEAM PHÒNG THẦU', value: 'TEAM PHÒNG THẦU' },
];

export const LANGUAGES: any = {
  en: {
    firstDayOfWeek: 1,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
    weekHeader: 'Wk',
  },
  vi: {
    firstDayOfWeek: 1,
    dayNames: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
    dayNamesShort: ['CN', 'Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy'],
    dayNamesMin: ['CN', 'Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy'],
    monthNames: [
      'Tháng Một',
      'Tháng Hai',
      'Tháng Ba',
      'Tháng Tư',
      'Tháng Năm',
      'Tháng Sáu',
      'Tháng Bảy',
      'Tháng Tám',
      'Tháng Chín',
      'Tháng Mười',
      'Tháng Mười Một',
      'Tháng Mười Hai',
    ],
    monthNamesShort: ['Th01', 'Th02', 'Th03', 'Th04', 'Th05', 'Th06', 'Th07', 'Th08', 'Th09', 'Th10', 'Th11', 'Th12'],
    today: 'Hôm nay',
    clear: 'Xoá',
    weekHeader: 'Tu',
  },
};

export const getValue = (value: any, defaultValue: any) => {
  return !isEmpty(value) ? value : defaultValue;
};

export const isJSON = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const toSlug = (text: string) => {
  return text
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');
};

export const toFormattedNumber = (value: number) => {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 3,
    minimumFractionDigits: 0,
  }).format(value);
};

export const toFormattedNumberVN = (value: number) => {
  return value ? (
    new Intl.NumberFormat('vi-VN', {
      maximumFractionDigits: 3,
      minimumFractionDigits: 0,
    }).format(value)
  ) : (
    <></>
  );
};

export const indexTemplate = (data: any, col: any) => {
  return col.rowIndex + 1;
};

export const longDateTemplate = (rowData: any, col: any) => {
  return getDataInPath(rowData, col.field) ? (
    <Moment date={getDataInPath(rowData, col.field)} format={CONSTANTS.DATE_FORMAT.LONG} />
  ) : (
    <></>
  );
};

export const timeTemplate = (rowData: any, col: any) => {
  return getDataInPath(rowData, col.field) ? (
    <Moment date={getDataInPath(rowData, col.field)} format={CONSTANTS.DATE_FORMAT.TIME} />
  ) : (
    <></>
  );
};

export const formatNumberTemplate = (rowData: any, col: any) => {
  return rowData && rowData[col.field] > 0 ? (
    <>
      <FormattedNumber
        value={Number(rowData[col.field])}
        maximumFractionDigits={
          col.field === 'percent' ||
          col.field === 'ty_le_d0' ||
          col.field === 'ty_le_d1' ||
          col.field === 'ty_le_d2' ||
          col.field === 'ty_le_d3'
            ? 3
            : 0
        }
        minimumFractionDigits={0}
      />
      {(col.field === 'percent' ||
        col.field === 'ty_le_d0' ||
        col.field === 'ty_le_d1' ||
        col.field === 'ty_le_d2' ||
        col.field === 'ty_le_d3') && <span> %</span>}
    </>
  ) : (
    <></>
  );
};

export const gtgtBodyTemplate = (rowData: any, col: any) => {
  return rowData.payment_type === CONSTANTS.PAYMENT_TYPE.THU_HO ? (
    <FormattedNumber value={Number(rowData.ch_gtgt)} maximumFractionDigits={0} minimumFractionDigits={0} />
  ) : rowData.payment_type === CONSTANTS.PAYMENT_TYPE.PHI_DICH_VU ? (
    <FormattedNumber value={Number(rowData.chiet_khau_gtgt)} maximumFractionDigits={0} minimumFractionDigits={0} />
  ) : (
    <></>
  );
};

export const shortDateTemplate = (rowData: any, col: any) => {
  return getDataInPath(rowData, col.field) ? (
    <Moment date={getDataInPath(rowData, col.field)} format={CONSTANTS.DATE_FORMAT.SHORT} />
  ) : (
    <></>
  );
};

export const numberTemplate = (rowData: any, col: any) => {
  return rowData[col.field] ? <FormattedNumber value={rowData[col.field]} maximumFractionDigits={0} /> : <>&nbsp;</>;
};

export const numberWithHyphenTemplate = (rowData: any, col: any) => {
  return rowData[col.field] ? <FormattedNumber value={rowData[col.field]} maximumFractionDigits={0} /> : <>&nbsp;</>;
};

export const numberWithDecimalTemplate = (rowData: any, col: any) => {
  return rowData[col.field] ? <FormattedNumber value={rowData[col.field]} maximumFractionDigits={3} /> : <>&nbsp;</>;
};

export const yesNoTemplate = (rowData: any, col: any) => {
  return rowData[col.field] ? 'CÓ' : 'KHÔNG';
};

export const durationTemplate = (rowData: any, col: any) => {
  // if (rowData[col.field]) {
  //   const minute = Math.floor(rowData[col.field] / 60);
  //   return minute > 0 ? `${minute}p${rowData[col.field] % 60}s` : `${rowData[col.field] % 60}s`;
  // } else {
  //   return <></>;
  // }
  return rowData[col.field] ? formatDuration(rowData[col.field]) : <></>;
};

export const loadingText = () => {
  return <span className="loading-text"></span>;
};

export const longDateFormat = (date: any) => {
  return date ? <Moment date={date} format={CONSTANTS.DATE_FORMAT.LONG} /> : <></>;
};

export const shortDateFormat = (date: any) => {
  return date ? <Moment date={date} format={CONSTANTS.DATE_FORMAT.SHORT} /> : <></>;
};

export const hiddenPhoneTemplate = (rowData: any, col: any) => {
  return rowData[col.field] ? <span>{'*'.repeat(5) + rowData[col.field].slice(5)}</span> : <></>;
};

export const getDifferenceBetweenTwoObject = (obj1: any, obj2: any) => {
  const result: any = {};
  if (Object.is(obj1, obj2)) {
    return {};
  }
  if (!obj2 || typeof obj2 !== 'object') {
    return obj2;
  }
  Object.keys(obj1 || {})
    .concat(Object.keys(obj2 || {}))
    .forEach((key) => {
      if (`${obj2[key]}` !== `${obj1[key]}` && !Object.is(obj1[key], obj2[key])) {
        result[key] = obj2[key];
      }
      if (typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
        const value = getDifferenceBetweenTwoObject(obj1[key], obj2[key]);
        if (value !== undefined && !isEmpty(value)) {
          result[key] = value;
        }
      }
    });
  return result;
};

export const getDataInPath = (data: any, field: string) => {
  const fields = field.split('.');
  if (fields.length === 1) {
    return data[fields[0]];
  } else if (fields.length === 2 && data[fields[0]] && data[fields[0]][fields[1]]) {
    return data[fields[0]][fields[1]];
  } else if (
    fields.length === 3 &&
    data[fields[0]] &&
    data[fields[0]][fields[1]] &&
    data[fields[0]][fields[1]][fields[2]]
  ) {
    return data[fields[0]][fields[1]][fields[2]];
  } else if (
    fields.length === 4 &&
    data[fields[0]] &&
    data[fields[0]][fields[1]] &&
    data[fields[0]][fields[1]][fields[2]] &&
    data[fields[0]][fields[1]][fields[2]][fields[3]]
  ) {
    return data[fields[0]][fields[1]][fields[2]][fields[3]];
  }
};

export const searchDataInPayload = (data: any[], displayFields: string[], search: string) => {
  if (!isEmpty(search)) {
    return data.filter((item: any) => {
      let isFound = false;
      for (const key of displayFields) {
        if (!isFound) {
          const fields = key.split('.');
          if (fields.length === 1 && item[key]) {
            isFound =
              removeVietnameseTones(`${toLower(item[key])}`).indexOf(removeVietnameseTones(toLower(search))) >= 0;
          } else if (fields.length === 2 && item[fields[0]] && item[fields[0]][fields[1]]) {
            isFound =
              removeVietnameseTones(`${toLower(item[fields[0]][fields[1]])}`).indexOf(
                removeVietnameseTones(toLower(search)),
              ) >= 0;
          } else if (
            fields.length === 3 &&
            item[fields[0]] &&
            item[fields[0]][fields[1]] &&
            item[fields[0]][fields[1]][fields[2]]
          ) {
            isFound =
              removeVietnameseTones(`${toLower(item[fields[0]][fields[1]][fields[2]])}`).indexOf(
                removeVietnameseTones(toLower(search)),
              ) >= 0;
          } else if (
            fields.length === 4 &&
            item[fields[0]] &&
            item[fields[0]][fields[1]] &&
            item[fields[0]][fields[1]][fields[2]] &&
            item[fields[0]][fields[1]][fields[2]][fields[3]]
          ) {
            isFound =
              removeVietnameseTones(`${toLower(item[fields[0]][fields[1]][fields[2]][fields[3]])}`).indexOf(
                removeVietnameseTones(toLower(search)),
              ) >= 0;
          }
        }
      }
      return isFound;
    });
  }
  return data;
};

export const searchDataInColumns = (data: any, filterCols: any) => {
  return data.filter((item: any) => {
    let isFound = true;
    for (const key of Object.keys(filterCols)) {
      const fields = key.split('.');
      if (fields.length === 1 && item[fields[0]]) {
        isFound =
          isFound &&
          removeVietnameseTones(`${toLower(item[fields[0]])}`).indexOf(
            removeVietnameseTones(toLower(filterCols[key].value)),
          ) >= 0;
      } else if (fields.length === 2 && item[fields[0]] && item[fields[0]][fields[1]]) {
        isFound =
          isFound &&
          removeVietnameseTones(`${toLower(item[fields[0]][fields[1]])}`).indexOf(
            removeVietnameseTones(toLower(filterCols[key].value)),
          ) >= 0;
      } else if (
        fields.length === 3 &&
        item[fields[0]] &&
        item[fields[0]][fields[1]] &&
        item[fields[0]][fields[1]][fields[2]]
      ) {
        isFound =
          isFound &&
          removeVietnameseTones(`${toLower(item[fields[0]][fields[1]][fields[2]])}`).indexOf(
            removeVietnameseTones(toLower(filterCols[key].value)),
          ) >= 0;
      } else if (
        fields.length === 4 &&
        item[fields[0]] &&
        item[fields[0]][fields[1]] &&
        item[fields[0]][fields[1]][fields[2]] &&
        item[fields[0]][fields[1]][fields[2]][fields[3]]
      ) {
        isFound =
          isFound &&
          removeVietnameseTones(`${toLower(item[fields[0]][fields[1]][fields[2]][fields[3]])}`).indexOf(
            removeVietnameseTones(toLower(filterCols[key].value)),
          ) >= 0;
      }
    }
    return isFound;
  });
};

export const sortDataInPayload = (data: any[], sortField: string, sortOrder: any) => {
  if (!isEmpty(sortField)) {
    return data.sort((o1: any, o2: any) => {
      const fieldArr = sortField.split('.');
      let value1 = 0;
      let value2 = 0;
      if (fieldArr.length === 1) {
        value1 = o1[fieldArr[0]];
        value2 = o2[fieldArr[0]];
      } else if (fieldArr.length === 2) {
        value1 = o1[fieldArr[0]] ? o1[fieldArr[0]][fieldArr[1]] : '';
        value2 = o2[fieldArr[0]] ? o2[fieldArr[0]][fieldArr[1]] : '';
      } else if (fieldArr.length === 3) {
        value1 = o1[fieldArr[0]] && o1[fieldArr[0]][fieldArr[1]] ? o1[fieldArr[0]][fieldArr[1]][fieldArr[2]] : '';
        value2 = o2[fieldArr[0]] && o2[fieldArr[0]][fieldArr[1]] ? o2[fieldArr[0]][fieldArr[1]][fieldArr[2]] : '';
      } else if (fieldArr.length === 4) {
        value1 =
          o1[fieldArr[0]] && o1[fieldArr[0]][fieldArr[1]] && o1[fieldArr[0]][fieldArr[1]][fieldArr[2]]
            ? o1[fieldArr[0]][fieldArr[1]][fieldArr[2]][fieldArr[3]]
            : '';
        value2 =
          o2[fieldArr[0]] && o2[fieldArr[0]][fieldArr[1]] && o2[fieldArr[0]][fieldArr[1]][fieldArr[2]]
            ? o2[fieldArr[0]][fieldArr[1]][fieldArr[2]][fieldArr[3]]
            : '';
      }
      if (value1 < value2) {
        return -1 * Number(sortOrder);
      }
      if (value1 > value2) {
        return 1 * Number(sortOrder);
      }
      return 0;
    });
  }
  return data;
};

export const removeVietnameseTones = (str: string) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, ' ');
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\\=|\\<|\\>|\?|\/|,|\.|\\:|\\;|\\'|\\"|\\&|\\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    ' ',
  );
  return str;
};

export const loadChunk = (filteredData: any[], index: number, length: number, totalRecords: number) => {
  if (index + length > totalRecords) {
    length = totalRecords - index;
  }
  const chunk = [];
  for (let i = 0; i < length; i++) {
    chunk[i] = { ...filteredData[i + index] };
  }
  return chunk;
};

export const isImage = (item: string) => {
  return item.match(/.(jpg|jpeg|png|gif)$/i);
};

export const cloneDeepArr = (item: any[]) => {
  const res = [];
  for (let i = 0; i < item.length; i++) {
    res.push({ ...item[i] });
  }
  return res;
};

export const resizeFile = (file: any) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      'JPEG',
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      'base64',
    );
  });

export const generateRandomText = (count: number) => {
  let rtn = '';
  for (let i = 0; i < count; i += 1) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
  }
  return rtn;
};

export const buildTagUser = (message: string) => {
  if (mentionRegex.test(message)) {
    const matchedRegex = message.match(mentionRegex);
    if (matchedRegex && !isEmpty(matchedRegex)) {
      for (let i = 0; i < matchedRegex.length; i++) {
        const matchedData = matchedRegex[i].match(mentionDetailRegex);
        if (matchedData && matchedData.length > 0) {
          const userIDs = matchedData[0].split('@');
          if (userIDs.length > 1) {
            message = message.replace(matchedRegex[i], `<a href="#">@${userIDs[1]}</a>`);
          }
        }
      }
    }
  }
  return message;
};

export const buildTagUserWithoutHtml = (message: string) => {
  if (mentionRegex.test(message)) {
    const matchedRegex = message.match(mentionRegex);
    if (matchedRegex && !isEmpty(matchedRegex)) {
      for (let i = 0; i < matchedRegex.length; i++) {
        const matchedData = matchedRegex[i].match(mentionDetailRegex);
        if (matchedData && matchedData.length > 0) {
          const userIDs = matchedData[0].split('@');
          if (userIDs.length > 1) {
            message = message.replace(matchedRegex[i], `@${userIDs[1]}`);
          }
        }
      }
    }
  }
  return message;
};

export const trimLastMessage = (message: string) => {
  return message.length > 40 ? message.substring(0, 40) + '...' : message;
};

export const trimGroupName = (message: string) => {
  return message.length > 80 ? message.substring(0, 80) + '...' : message;
};

export const getDuration = (date: any) => {
  const duration =
    moment.duration(moment().diff(moment(date))).asHours() < 24
      ? moment.duration(moment().diff(moment(date))).asMinutes() < 60
        ? `${moment
            .duration(moment().diff(moment(date)))
            .asMinutes()
            .toFixed(0)}p trước`
        : `${moment
            .duration(moment().diff(moment(date)))
            .asHours()
            .toFixed(1)}g trước`
      : `${moment
          .duration(moment().diff(moment(date)))
          .asDays()
          .toFixed(0)}ng trước`;
  return duration !== '' ? `(${duration})` : '';
};

export const formatChatTime = (date: any) => {
  if (moment(Number(date)).get('date') === moment().get('date')) {
    return `---------- ${moment(Number(date)).format('HH:mm')}, Hôm nay ----------`;
  }

  if (moment(Number(date)).get('date') === moment().subtract(1, 'day').get('date')) {
    return `---------- ${moment(Number(date)).format('HH:mm')}, Hôm qua ----------`;
  }

  return `---------- ${moment(Number(date)).format('HH:mm, DD/MM/YYYY')} ----------`;
};

export const formatSystemAdv = (item: any) => {
  try {
    const messageObj = item.message.split('\n');
    return (
      <div className="system-adv-content">
        <p className="text-bold">{messageObj[0]}</p>
        <p>{messageObj[1]}</p>
        <p>{messageObj[2]}</p>
        <p>{messageObj[3]}</p>
        <p>{messageObj[4]}</p>
        <p>{messageObj[5]}</p>
        <p>
          <small className="text-center d-block">{formatChatTime(item.created_at)}</small>
        </p>
      </div>
    );
  } catch (e) {
    return <div className="system-adv-content">{item.message}</div>;
  }
};

export const isReserving = (owner: any) => {
  return (
    !isEmpty(owner.reserved_at) && moment(owner.reserved_at).add(CONSTANTS.RESERVED_TIME, 'minutes').isAfter(moment())
  );
};

export const isAvailableForReserveInstant = (owner: any, userGroupID: string, userID: number) => {
  const priceQuotes =
    owner.price_quotes
      ?.filter((item: any) => {
        if (item.quote_type === 'CÓ XE NHẬN') {
          if (!isEmpty(owner.reserved_at)) {
            return moment(item.created_at).isBefore(moment(owner.reserved_at).add(CONSTANTS.RESERVED_TIME, 'minutes'));
          }
          return moment(item.created_at).isBefore(
            moment(owner.created_at).add(CONSTANTS.LOCKED_TIME_FOR_GROUP, 'minutes'),
          );
        }
        return false;
      })
      .sort((o1: any, o2: any) => {
        if (o1.driver_total === o2.driver_total) {
          return moment(o1.created_at).valueOf() - moment(o2.created_at).valueOf();
        }
        return o1.driver_total - o2.driver_total;
      })
      .reduce((acc: any[], item: any) => {
        let found = false;
        for (let i = 0; i < acc.length; i++) {
          if (item.created_by === acc[i].created_by) {
            found = true;
            break;
          }
        }
        if (!found) {
          acc.push(item);
        }
        return acc;
      }, []) || [];

  let lockedMinute = !isEmpty(owner.reserved_at)
    ? priceQuotes.length
    : CONSTANTS.LOCKED_TIME_FOR_GROUP + priceQuotes.length;
  for (let i = 0; i < priceQuotes.length; i++) {
    if (Number(priceQuotes[i].created_by) === userID) {
      lockedMinute = !isEmpty(owner.reserved_at) ? i : CONSTANTS.LOCKED_TIME_FOR_GROUP + i;
      break;
    }
  }

  return {
    available:
      userGroupID === owner.group_id ||
      moment(owner.reserved_at || owner.created_at)
        .add(lockedMinute, 'minutes')
        .isBefore(moment()),
    lockedMinute,
  };
};

export const isAvailableForReserveInstantV2 = (owner: any, userGroupID: string, userID: number) => {
  const priceQuotes =
    owner.price_quotes
      ?.filter((item: any) => {
        if (item.quote_type === 'CÓ XE NHẬN') {
          if (!isEmpty(owner.reserved_at)) {
            return moment(item.created_at).isBefore(moment(owner.reserved_at).add(CONSTANTS.RESERVED_TIME, 'minutes'));
          }
          return moment(item.created_at).isBefore(
            moment(owner.created_at).add(CONSTANTS.LOCKED_FOR_PRICE_QUOTE, 'minutes'),
          );
        }
        return false;
      })
      .sort((o1: any, o2: any) => {
        if (o1.driver_total === o2.driver_total) {
          return moment(o1.created_at).valueOf() - moment(o2.created_at).valueOf();
        }
        return o1.driver_total - o2.driver_total;
      })
      .reduce((acc: any[], item: any) => {
        let found = false;
        for (let i = 0; i < acc.length; i++) {
          if (item.created_by === acc[i].created_by) {
            found = true;
            break;
          }
        }
        if (!found) {
          acc.push(item);
        }
        return acc;
      }, []) || [];

  let lockedMinute = !isEmpty(owner.reserved_at)
    ? priceQuotes.length
    : CONSTANTS.LOCKED_FOR_PRICE_QUOTE + priceQuotes.length;
  for (let i = 0; i < priceQuotes.length; i++) {
    if (Number(priceQuotes[i].created_by) === userID) {
      lockedMinute = !isEmpty(owner.reserved_at) ? i : CONSTANTS.LOCKED_FOR_PRICE_QUOTE + i;
      break;
    }
  }

  return {
    available: moment(owner.reserved_at || owner.created_at)
      .add(lockedMinute, 'minutes')
      .isBefore(moment()),
    lockedMinute,
  };
};

export const isTimeForPriceQuote = (time: any, now: any) => {
  return moment(time).add(CONSTANTS.LOCKED_FOR_PRICE_QUOTE, 'minutes').isAfter(now);
};

// Deprecated
export const isTimeForReserve = (owner: any, userID: number) => {
  const reservedIDs = owner.i_reserved_list?.split(',').map((it: any) => Number(it)) || [];
  const idx = reservedIDs.findIndex((it: any) => it === userID);
  if (idx >= 0) {
    return moment(owner.is_reserved_at || owner.i_created_at)
      .add(CONSTANTS.LOCKED_FOR_PRICE_QUOTE + CONSTANTS.LOCKED_TIME_FOR_GROUP * (idx + 1), 'minutes')
      .isAfter(moment());
  }
  return moment(owner.i_created_at)
    .add(CONSTANTS.LOCKED_FOR_PRICE_QUOTE + CONSTANTS.LOCKED_TIME_FOR_GROUP * reservedIDs.length, 'minutes')
    .isAfter(moment());
};

// Deprecated
export const reserveCountDown = (owner: any, userID: number) => {
  const reservedIDs = owner.i_reserved_list?.split(',').map((it: any) => Number(it)) || [];
  const idx = reservedIDs.findIndex((it: any) => it === userID);
  if (idx >= 0) {
    return moment(owner.is_reserved_at || owner.i_created_at)
      .add(CONSTANTS.LOCKED_FOR_PRICE_QUOTE + CONSTANTS.LOCKED_TIME_FOR_GROUP * idx, 'minutes')
      .diff(moment(), 'seconds');
  }
  return moment(owner.is_reserved_at || owner.i_created_at)
    .add(CONSTANTS.LOCKED_FOR_PRICE_QUOTE + CONSTANTS.LOCKED_TIME_FOR_GROUP * reservedIDs.length - 1, 'minutes')
    .diff(moment(), 'seconds');
};

export const formatChatMessageTime = (date: any) => {
  if (moment(Number(date)).get('date') === moment().get('date')) {
    return moment(Number(date)).format('HH:mm');
  }

  if (moment(Number(date)).get('date') === moment().subtract(1, 'day').get('date')) {
    return `Hôm qua, ${moment(Number(date)).format('HH:mm')}`;
  }

  return moment(Number(date)).format('DD/MM, HH:mm');
};

export const formatDuration = (second: number) => {
  return moment.utc(second * 1000).format('mm:ss');
};

export const formatTimeDuration = (beginTime: any, endTime: any) => {
  const second = moment(endTime).diff(moment(beginTime), 'seconds');
  if (second < 60) {
    return `${second}s`;
  } else if (second < 3600) {
    return `${Math.floor(second / 60)}p ${second % 60}s`;
  } else if (second < 86400) {
    const minute = Math.floor(second % 3600);
    return `${Math.floor(second / 3600)}g ${Math.floor(minute / 60)}p ${minute % 60}s`;
  } else {
    const hour = Math.floor(second % 86400);
    const minute = Math.floor(hour % 3600);
    return `${Math.floor(second / 86400)}ng ${Math.floor(hour / 3600)}g ${Math.floor(minute / 60)}p ${minute % 60}s`;
  }
};

export const formatDurationToTime = (time: any) => {
  const second = moment().diff(moment(time), 'seconds');
  if (second < 60) {
    return `${second}s`;
  } else if (second < 3600) {
    return `${Math.floor(second / 60)}p`;
  } else if (second < 86400) {
    return `${Math.floor(second / 3600)}g`;
  } else {
    return `${Math.floor(second / 86400)}ng`;
  }
};

export const formatDurationToTimeFull = (time: any) => {
  const second = moment().diff(moment(time), 'seconds');
  if (second < 60) {
    return `${second} giây`;
  } else if (second < 3600) {
    return `${Math.floor(second / 60)} phút`;
  } else if (second < 86400) {
    return `${Math.floor(second / 3600)} giờ`;
  } else {
    return `${Math.floor(second / 86400)} ngày`;
  }
};

export const autoConvertToHyperlink = (text: string) => {
  const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  return text.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
};

export const isTextContainArrayItem = (text: string, array: string[]) => {
  for (let i = 0; i < array.length; i++) {
    if (text.indexOf(array[i]) >= 0) {
      return true;
    }
  }
  return false;
};

export const formatBreakLineTemplate = (rowData: any, col: any) => {
  const data = getDataInPath(rowData, col.field);
  return (
    data &&
    `${data}`.split(',').map((item: any, index: number) => {
      return (
        <span key={index}>
          {item}
          <br />
        </span>
      );
    })
  );
};

export const isSecured = (data: any, user: any) => {
  return (
    data &&
    data.is_secured &&
    !user.hasSystemRole(CONSTANTS.SYSTEM_ROLES.BAO_MAT_TAI_XE_CHU_HANG) &&
    Number(data.secured_by) !== user.id
  );
};

export const hidePriceNumber = (input: string) => {
  const parts = input.split(',');
  if (parts.length === 3) {
    return `${parts[0]},***,***`;
  }
  return `${parts[0]},***`;
};

export const getVehicleContainerWeightOptions = (type: string) => {
  let data = [];
  switch (type) {
    case 'M':
      for (let i = 12.1; i < 31; i += 0.1) {
        data.push({ label: `${i.toFixed(1)}M`, value: `${i.toFixed(1)}M` });
      }
      break;
    case 'F':
      for (let i = 40; i <= 70; i++) {
        data.push({ label: `${i}F`, value: `${i}F` });
      }
      break;
  }
  return data;
};

export const getVehicleTypeOptions = () => {
  let data: any[] = [];

  VEHICLE_TYPE_1.forEach((item: string) => {
    data.push({ label: `${item}`, value: `${item}` });
  });

  VEHICLE_TYPE_2.forEach((item: string) => {
    data.push({ label: `${item}`, value: `${item}` });
  });

  VEHICLE_TYPE_3.forEach((item: string) => {
    data.push({ label: `${item}`, value: `${item}` });
  });

  VEHICLE_TYPE_4.forEach((item: string) => {
    data.push({ label: `${item}`, value: `${item}` });
  });

  return data;
};

export const toLicensePlateFormat = (str: string) => {
  if (!isEmpty(str)) {
    str = toUpper(str).replace(/[^0-9A-Z\\-]+/g, '');
    for (let i = str.length - 1; i >= 0; i--) {
      if (str.charAt(i).match(/[A-Z]/i)) {
        if (str.charAt(i + 1) !== '-') {
          str = str.slice(0, i + 1) + '-' + str.slice(i + 1);
        }
        break;
      }
    }
    return str;
  }
  return '';
};

export const isManagedUser = (user: any, managedUsers: any[], data: any) => {
  return user.isAdmin() || managedUsers.includes(Number(data.assigned?.user_id));
};

export const hasExecutePlanRole = (user: any, role: string) => {
  return user.execute_the_plan_roles?.indexOf(role) >= 0;
};

export const isAssigned = (user: any, data: any) => {
  if (data && !isEmpty(data.assigned)) {
    return (
      Number(data.assigned.user_id) === Number(user.id) ||
      !moment(data.assigned.assigned_until).isValid() ||
      moment().isAfter(moment(data.assigned.assigned_until))
    );
  }
  return true;
};

export const isUrl = (text: string) => {
  const urlRegex = /(\bhttps?:\/\/[^\s/$.?#].[^\s]*|(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?\b)/gi;
  return urlRegex.test(text);
};

export const base64ToFile = (base64String: string, filename: string, mimeType: string) => {
  // Remove data URL prefix if present (e.g., "data:image/png;base64,")
  const base64Data = base64String.split(',')[1] || base64String;

  // Decode base64 to binary
  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Create a Blob and then a File
  const blob = new Blob([bytes], { type: mimeType });
  return new File([blob], filename, { type: mimeType });
};

export const roundWithDec = (value: number, decimal: number = 0) => {
  return Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
};

export const roundWith3Dec = (value: number) => {
  return roundWithDec(value, 3);
};

export const hinhThucCongNoTemplate = (rowData: any) => {
  return rowData.hinh_thuc_cong_no === CONSTANTS.HINH_THUC_CONG_NO.CN_KHONG_BAO_LANH
    ? `${rowData.hinh_thuc_cong_no} - (${rowData.cn_ko_bao_lanh_day} NGÀY) - (${rowData.cn_ko_bao_lanh_day} NGÀY)`
    : rowData.hinh_thuc_cong_no === CONSTANTS.HINH_THUC_CONG_NO.CN_BAO_LANH
    ? `${rowData.hinh_thuc_cong_no} - (${rowData.cn_bao_lanh_day} NGÀY) - (${rowData.cn_bao_lanh_day_2} NGÀY)`
    : CONSTANTS.HINH_THUC_CONG_NO.KHONG_CONG_NO;
};

export const exportToCSV = (data: any, filename = 'data.csv') => {
  const csvRows = [];

  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(',')); // Add header row

  // Add data rows
  for (const row of data) {
    const values = headers.map((header) => JSON.stringify(row[header], null, 2)); // Escape values
    csvRows.push(values.join(','));
  }

  // Create CSV string
  const csvString = csvRows.join('\n');

  // Create a Blob object
  const blob = new Blob([csvString], { type: 'text/csv' });

  // Create a link and trigger the download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const workingTimeFormat = (date: any, startTime: any, endTime: any) => {
  const beginWorkingTime = moment(date).set({ hour: 8, minute: 0, second: 0, millisecond: 0 });
  const endWorkingTime = moment(date).set({ hour: 17, minute: 0, second: 0, millisecond: 0 });
  const begin = moment(startTime).isBefore(beginWorkingTime) ? beginWorkingTime : moment(startTime);
  const end = moment(endTime).isAfter(endWorkingTime) ? endWorkingTime : moment(endTime);
  return `${moment(begin).format(CONSTANTS.TIME_FORMAT_SHORT)} - ${moment(end).format(CONSTANTS.TIME_FORMAT_SHORT)}`;
};

// TẠM ỨNG THANH TOÁN của đơn: CÓ / KHÔNG theo giá trị trong DB.
export const tamUngThanhToanTemplate = (rowData: any) => (rowData.tam_ung_thanh_toan === true ? 'CÓ' : 'KHÔNG');

export const chungTuTemplate = (rowData: any) => {
  return rowData.is_chung_tu ? `CÓ - ${rowData.ngay_chung_tu} NGÀY - ${rowData.noi_dung_chung_tu}` : '';
};
